import { useState } from 'react';
import { Table, Card, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faImages } from '@fortawesome/free-solid-svg-icons';
import './Maintenance.css';

const phaseData = [
  {
    phase: 'Phase 1',
    link: 'https://drive.google.com/drive/folders/1qfxRKQpG3XWI6YTDFwd69izSG1uXD7r3',
  },
  {
    phase: 'Phase 2',
    link: 'https://drive.google.com/drive/folders/10C9HLRBY_HubaQWEp3QjqVQbQC8Q2BFh',
  },
  {
    phase: 'Phase 3',
    link: 'https://drive.google.com/drive/folders/1yQGAVuPsevBfiNH9KWqPrvdf2sfcbB7D',
  },
  {
    phase: 'Phase 4',
    link: 'https://drive.google.com/drive/folders/1lS07lArA-wD5pB5AQZJufnS4_AlYRcMl',
  },
];

const Maintenance = () => {
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  return (
    <Container fluid className="maintenance-container py-1 px-0">
      <Row>
        <Col>
          <Card className="maintenance-card shadow-sm">
            <Card.Body>
              <h2 className="text-left mb-2">Plot Maintenance</h2>

              <div className="maintenance-info mb-5">
                <Card className="info-card bg-light border-0">
                  <Card.Body>
                    <p className="lead mb-0">
                      At Aparna Western Meadows, we ensure that maintenance,
                      including plot cleaning, is managed with attention to
                      detail. Plots are cleaned twice a year, and owners with
                      gardens or fenced-off areas are responsible for
                      maintaining their own plots. Once cleaning is completed,
                      photos are uploaded to each plot's folder, allowing remote
                      owners to easily view the updates.
                    </p>
                  </Card.Body>
                </Card>
              </div>

              <div className="table-responsive">
                <Table hover className="maintenance-table">
                  <thead className="table-light">
                    <tr>
                      <th>Phase</th>
                      <th className="text-center">Photos</th>
                    </tr>
                  </thead>
                  <tbody>
                    {phaseData.map((phase, index) => (
                      <tr
                        key={phase.phase}
                        onMouseEnter={() => setHoveredRow(index)}
                        onMouseLeave={() => setHoveredRow(null)}
                        className={
                          hoveredRow === index ? 'table-hover-active' : ''
                        }
                      >
                        <td className="align-middle">{phase.phase}</td>
                        <td className="text-center">
                          <a
                            href={phase.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-primary btn-sm gallery-link"
                          >
                            <FontAwesomeIcon icon={faImages} className="me-2" />
                            View Photos
                            <FontAwesomeIcon
                              icon={faExternalLinkAlt}
                              className="ms-2 external-link-icon"
                            />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Maintenance;
